import { BaseSopOperation } from "./_Base";
import { InputCloneMode } from "../../../engine/poly/InputCloneMode";
import { TypedNodePathParamValue } from "../../../core/Walker";
import { CoreObject } from "../../../core/geometry/Object";
import { CameraAttribute } from "../../../core/camera/CoreCamera";
import { CameraSopNodeType } from "../../poly/NodeContext";
const _CameraRenderSceneSopOperation = class extends BaseSopOperation {
  static type() {
    return CameraSopNodeType.RENDER_SCENE;
  }
  cook(inputCoreGroups, params) {
    const objects = inputCoreGroups[0].objects();
    if (this._node) {
      _CameraRenderSceneSopOperation.updateObject({ objects, params, node: this._node, active: true });
    }
    return this.createCoreGroupFromObjects(objects);
  }
  static updateObject(options) {
    const { objects, params, node, active } = options;
    const relativeOrAbsolutePath = params.node.path();
    const foundNode = node.node(relativeOrAbsolutePath);
    if (foundNode && active) {
      const absolutePath = foundNode.path();
      for (let object of objects) {
        CoreObject.addAttribute(object, CameraAttribute.RENDER_SCENE_PATH, absolutePath);
      }
    } else {
      for (let object of objects) {
        CoreObject.deleteAttribute(object, CameraAttribute.RENDER_SCENE_PATH);
      }
    }
  }
};
export let CameraRenderSceneSopOperation = _CameraRenderSceneSopOperation;
CameraRenderSceneSopOperation.DEFAULT_PARAMS = {
  node: new TypedNodePathParamValue("")
};
CameraRenderSceneSopOperation.INPUT_CLONED_STATE = InputCloneMode.FROM_NODE;
